
import {trl} from '~/services/intl'
import {logout} from '~/services/user'

export default function() {
    return <button onClick={logout} className='user-info__info_exit'>
        {trl('Выход')}
    </button>
}
